export { default } from "./page-saskatchewan";
